import classNames from 'classnames'
import React, { useState } from 'react'
import Icon from 'src/components/forms/icon/icon'

import { CLASS_PREFIX } from 'src/constants'
import { COLOR_TYPE_PRIMARY } from 'src/utils/color'
import './project_info_card.scss'

const cls = `${CLASS_PREFIX}project-info-card`

type Props = {
  title: string;
  content: React.ReactNode;
  icon: React.ReactNode;
}

export const ProjectInfoCard: React.FC<Props> = ({ title, content, icon }) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <div
      className={classNames(`${cls}`, {
        [`${cls}__expanded`]: expanded
      })}
    >
      <div
        className={`${cls}__toggle`}
        aria-expanded={expanded}
        aria-controls={`${cls}__text`}
        onClick={() => {
          setExpanded(!expanded)
        }}
      >
        <div className={`${cls}__icon`}>
          {icon}
        </div>
        <div className={`${cls}__title`}>{title}</div>
        <Icon className={`${cls}__toggle-arrow`} name={expanded ? 'arrow-up' : 'arrow-down'} size={16} color={COLOR_TYPE_PRIMARY} />
      </div>
      <div className={`${cls}__text`}>{content}</div>
    </div>
  )
}
